import React, { useEffect, useState } from 'react';
import { Row, Card, Col, Form } from 'react-bootstrap';
import BackNextButton from "../../../Common/BackNextButton";
import { CheckboxInput, SelectInput, TextInput } from '../../../Helpers/Inputs';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { mixed, object, string } from 'yup';
import { ConvertStringToBoolean } from '../../../Helpers/Formatters/ConvertBoolean';
import { ConvertBooleanToString } from '../../../Helpers/Formatters/ConvertBoolean';
import PropTypes from "prop-types";
import { httpRequest } from "../../../../httpRequest";
import { SESSION_STORAGE_ATTESTATION, setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage'
import { CircularProgress, FormLabel } from "@material-ui/core";
import "./Attestation.scss";

export default function Attestation(props) {

  const [loading, setLoading] = useState(true);
  const [attestationVerbiage, setVerbiage] = useState('');
  const isSymetraTerm = props.showAttestation || (props.quoterState.carrierID === 1018 && props.quoterState.productID === 1039);
  const isJohnHancockCoreTerm = props.quoterState.carrierID === 1002 && props.quoterState.productID === 1046;

  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: Attestation.ValidationSchema(isSymetraTerm),
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const oneClickAccountId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.oneClickAccountId;

  const getVerbiage = async () => {
    // replace once we have real endpoint
    setLoading(true);
    const queryParams = {
      OneClickAccountID: oneClickAccountId,
      carrierCode: props.quoterState.carrier,
      productCode: props.quoterState.productCode,
      productCategory: props.quoterState.productCategory,
      CovrQuoterCarrierID: props.quoterState.carrierID,
      CovrQuoterProductID: props.quoterState.productID
    }
    const response = await httpRequest.post(`${process.env.REACT_APP_COVR_SERVICES_URL}/api/Account/GetCarrierProductAndCarrierFirmAttestation`, queryParams);
    setVerbiage(response);
    setSessionStorageItem(SESSION_STORAGE_ATTESTATION, response);
    setLoading(false);
  }

  useEffect(() => {
    const sessionVerbiage = getSessionStorageItem(SESSION_STORAGE_ATTESTATION);

    if (sessionVerbiage !== null && sessionVerbiage !== '') {
      setVerbiage(sessionVerbiage);
      setLoading(false);
      return;
    }

    getVerbiage();
  }, [])

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  }

  const getCarrier = () => {
    switch (props.quoterState.carrierName) {
      case 'Legal & General':
        return 'Banner Life';
      case 'AIG':
        return 'Corebridge';
      case 'Prudential':
      case 'Pacific Life':
      case 'John Hancock':
      case 'Protective':
      case 'Symetra':
        return props.quoterState.carrierName;
      case 'SYMETRA LIFE INSURANCE COMPANY':
        return 'Symetra';
    }
  }

  const getCapacity = () => {
    const capacity = [
      { value: "", label: "--Select One--", disabled: true},
      { value: "Personal", label: "Personal" },
      { value: "Professional", label: "Professional" },
  ]
    return capacity;
  }

  if (loading)
    return <div className="d-flex justify-content-center p-5"><CircularProgress /></div>;

  return (
    <form onSubmit={handleSubmit(props.onNext)}>
      <Row className="justify-content-center pt-4 client-coverage">
        <Col lg={6}>
          <div>
            <Row>
              <p className='content-heading'>Carrier Attestation</p>
            </Row>
            <Row className='mt-1 ml-3'>
              {/*How should we handle notices like the following?*/}
              <p><b>{`Note: ${!isJohnHancockCoreTerm ? "Effective February 13," : ""} ${getCarrier()} now accepts an attestation in lieu of your signature on completed applications. Please attest to the following language to proceed with your client.`}</b></p>
            </Row>
            {
              isSymetraTerm &&
              <Row>
                <Col sm={{span : 8, offset: 2}}>
                <Form.Group className='mt-4'>
                  <FormLabel>How long have you known the insured/applicant?</FormLabel>
                  <TextInput
                    name="howLongKnown"
                    id="howLongKnown"
                    value={props.formState.howLongKnown}
                    errors={errors && errors.howLongKnown}
                    inputRef={register}
                    onChange={(e) => handleValueChange('howLongKnown', e.target.value)}
                    className='text-input-center'
                  />
                </Form.Group>
                <Form.Group className='mt-4'>
                  <FormLabel>In what capacity?</FormLabel>
                  <SelectInput
                    name="capacity"
                    id="capacity"
                    value={props.formState.capacity}
                    onChange={(e) => handleValueChange('capacity', e.target.value)}
                    selectOptions={getCapacity()}
                    errors={errors.capacity}
                    inputRef={register}
                    hideEmptyOption
                    className='select-input-center'
                  />
                </Form.Group>
                <Form.Group className='mt-4'>
                <FormLabel>What is the source of funds to pay premiums on this policy, should it be issued?</FormLabel>
                  <TextInput
                    name="sourceOfFunds"
                    id="sourceOfFunds"
                    value={props.formState.sourceOfFunds}
                    errors={errors && errors.sourceOfFunds}
                    inputRef={register}
                    onChange={(e) => handleValueChange('sourceOfFunds', e.target.value)}
                    className='text-input-center'
                  />
                </Form.Group>
                <Form.Group className='mt-4'>
                <FormLabel>If this Drop Ticket was completed in a state different than the Owner’s resident state please indicate why. N/A if not applicable.</FormLabel>
                  <TextInput
                    name="notAppliedInResidentState"
                    id="notAppliedInResidentState"
                    value={props.formState.notAppliedInResidentState}
                    errors={errors && errors.notAppliedInResidentState}
                    inputRef={register}
                    onChange={(e) => handleValueChange('notAppliedInResidentState', e.target.value)}
                    className='text-input-center'
                  />
                </Form.Group>
                </Col>
              </Row>
            }
            <Row className='p-3'>
              <Card className='card-scroll'>
                <div className='content-title' dangerouslySetInnerHTML={{ __html: attestationVerbiage.carrierAttestation }}></div>
                {/*                <p className='content-title'>
                  The above named agent clicked on the I AGREE/SUBMIT button at the time listed, agreeing that:
                </p>
                <p className='content-title'>
                  I certify that the following statements are true and accurate:
                </p>
                <div className='content-menu'>
                  <p>(1) I am a duly licensed and appointed (if appointment is required) life insurance agent in the state in which the applicant was solicited and in the state in which the policy, if one is issued, will be delivered.  The plan and amount of insurance identified is appropriate in view of the applicant's insurance needs and financial objectives.  The information provided is complete, accurate, and correctly recorded.  All forms required to be delivered at time of solicitation have been delivered and all other required forms (including privacy notices, if necessary) have been or will be provided to the applicant.</p>
                  <p>(2) I confirmed with the proposed applicant that a) he or she does not have any existing life insurance or annuities; b) this coverage does not replace or change any current insurance or annuity with any company; or c) if a replacement is involved, I have discussed the advantages and disadvantages of the replacement with the applicant, and determined that the transaction is appropriate.  If existing coverage is involved, I have obtained from the applicant the information required by state replacement laws and I have read the Important Notice Regarding Replacement aloud to the applicant or the applicant did not wish the notice to be read aloud.</p>
                  <p>  (3) I do not know or have any reason to believe that any group of investors plans to obtain any right, title, or interest in any policy issued as a result of this application.  To the best of my knowledge, neither the proposed insured nor owner has ever sold, assigned or transferred ownership in any life policy to an outside investor group.</p>
                </div>
                <p className='content-title'>I authorize Banner Life Insurance Company (collectively "Company") to obtain such administrative information as may be necessary to complete any life insurance application, replacement forms or supplemental forms resulting from this lead submission, provided, however, that any item of information or question from the applicant requiring the act or advice of a licensed life insurance agent will be referred to me for action before the application can be completed or will be obtained by life licensed personnel of the Company.  I will personally review the application created from this data and administrative information provided by the applicant and contact him or her concerning any incomplete or inconsistent information and I will not deliver the policy unless I have completed my review and am satisfied that the policy, application and all attached papers, if any, are complete and accurate.</p>
                <p className='content-title'>CA:  If an employer is applying for corporate owned life insurance, I confirmed with the proposed owner-employer that the proposed insured is not a nonexempt employee.</p>
                <p className='content-title'>AZ, CO, HI, TX, UT:  If a replacement is involved, I have or will have provided paper copies of any electronically presented sales materials used in a presentation to the applicant no later than at the time of delivery of the policy.</p>
                <p className='content-title'>ME:  I have or will have completed and reviewed the required Preliminary Statement of Policy Cost form with the applicant before policy issuance or delivery of the policy.  The Preliminary Statement of Policy Cost form is included in the quotation system.</p>
                <p className='content-title'>I acknowledge that clicking the "I Agree/Submit" button below constitutes 1) my consent to do business and to conduct business electronically and 2) my signature on the form and has the same effect as if I personally signed the form.  Where permitted by state law, I authorize the Company to affix my signature to the life insurance application, replacement form and all other forms required to be completed during the application process.</p>*/}
              </Card>
            </Row>
          </div>
          <Row>
            <p className='content-heading'>Firm Attestation</p>
          </Row>
          <Row className='p-3'>
            <Card className='card-scroll'>
              <p className='content-title'>{attestationVerbiage.firmAttestation}</p>
            </Card>
          </Row>
          <Form.Group>
            <CheckboxInput
              name="attestation"
              id="attestation"
              label="Attestation: By checking the box, I acknowledge that I have read and understand the CARRIER & FIRM ATTESTATIONS above."
              checked={ConvertStringToBoolean(props.formState.attestation)}
              onChange={e => handleValueChange('attestation', ConvertBooleanToString(e.target.checked))}
              errors={errors.attestation}
              inputRef={register}
              color="primary"
              disabled={loading}
              className="attestation"
              labelClassName="setCheckBox"
            />
          </Form.Group>
        </Col>
      </Row>
      <BackNextButton onBack={props.onBack} />
    </form>
  )
}

Attestation.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
};

Attestation.DefaultFormState = () => {
  return {
    attestation: false,
    howLongKnown: '',
    capacity: '',
    sourceOfFunds: '',
    notAppliedInResidentState: '',
  }
}

Attestation.ValidationSchema = (isSymetraTerm) => {
  return object().shape({
      attestation: mixed().oneOf([true], 'This field is required.'),
      howLongKnown: isSymetraTerm ? string().required("This field is required.").max(25, 'Maximum 25 characters allowed.') : string().notRequired(),
      capacity: isSymetraTerm ? string().required("This field is required.") : string().notRequired(),
      sourceOfFunds: isSymetraTerm ? string().required("This field is required.").max(25, 'Maximum 25 characters allowed.') : string().notRequired(),
      notAppliedInResidentState: isSymetraTerm ? string().required("This field is required.").max(75, 'Maximum 75 characters allowed.') : string().notRequired(),
    })
}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/Attestation/Attestation.js